import { GET_ON_INIT } from "@/lib/consts";
import { atom } from "jotai";
import { useAtom } from "jotai/react";
import { atomWithStorage } from "jotai/utils";

export const videoCardSizeAtom = atomWithStorage<VideoCardSize>(
  "videocard-size",
  "lg",
  undefined,
  GET_ON_INIT,
);

export function useVideoCardSizes(allowedCardSizes: VideoCardSize[]) {
  const [size, setSize] = useAtom(videoCardSizeAtom);

  const setNextSize = () => {
    const currentIndex = allowedCardSizes.indexOf(size);
    const nextIndex = (currentIndex + 1) % allowedCardSizes.length;
    setSize(allowedCardSizes[nextIndex]);
  };

  // Assuming the next size is immediately after the current size in the array
  const nextSize =
    allowedCardSizes[
      (allowedCardSizes.indexOf(size) + 1) % allowedCardSizes.length
    ];

  return { size, setSize, nextSize, setNextSize };
}

// also acts as a Report is open indicator.
export const videoReportAtom = atom<Video | null>(null);

// used to keep track of the current page's contextual channel ID if we are on a video-related page (such as watch or edit)
// should be set back to NULL whenever the page is unmounted.
export const currentVideoChannelAtom = atom<string | null>(null);
